import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["overlay", "modal", "submitButton"]

  selectOption() {
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = false
    }
  }
}
